// Proiezione Web Mercator + tile satellitari Esri per l'editor CAD.
// Coordinate interne in METRI locali (x=est, y=nord). Mondo Konva in pixel mercatore z=Z.
const R = 6378137;
const Z = 19;
const TILE = 256;
const DEG = 111320;
export const ESRI = (z, x, y) => `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/${z}/${y}/${x}`;

function globalPx(lat, lng) {
  const n = TILE * 2 ** Z;
  const siny = Math.min(Math.max(Math.sin((lat * Math.PI) / 180), -0.9999), 0.9999);
  return [
    ((lng + 180) / 360) * n,
    (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)) * n,
  ];
}

export function makeProjection(lat0, lng0) {
  const [cgx, cgy] = globalPx(lat0, lng0);
  const groundRes = (Math.cos((lat0 * Math.PI) / 180) * 2 * Math.PI * R) / (TILE * 2 ** Z);
  const ppm = 1 / groundRes; // px mondo per metro al suolo
  const kLng = DEG * Math.cos((lat0 * Math.PI) / 180);
  return {
    ppm, TILE,
    toM: (lat, lng) => [(lng - lng0) * kLng, (lat - lat0) * DEG],
    toLL: (x, y) => [lat0 + y / DEG, lng0 + x / kLng],
    mToWorld: ([x, y]) => [x * ppm, -y * ppm],
    worldToM: (wx, wy) => [wx / ppm, -wy / ppm],
    tiles(radius = 4) {
      const ctx = Math.floor(cgx / TILE), cty = Math.floor(cgy / TILE);
      const out = [];
      for (let dx = -radius; dx <= radius; dx++)
        for (let dy = -radius; dy <= radius; dy++) {
          const tx = ctx + dx, ty = cty + dy;
          out.push({ key: `${tx}-${ty}`, url: ESRI(Z, tx, ty), x: tx * TILE - cgx, y: ty * TILE - cgy });
        }
      return out;
    },
    span(radius = 4) { return (2 * radius + 1) * TILE; },
  };
}

export const polyAreaM = (pts) =>
  Math.abs(pts.reduce((s, p, i) => { const q = pts[(i + 1) % pts.length]; return s + p[0] * q[1] - q[0] * p[1]; }, 0)) / 2;
export const dist = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1]);
